/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const CustomerWrapperPLA = () => ({
    CustomerWrapperPLA: {
        '&.PLA': {
            padding: '0 15px',
            maxWidth: '1270px',
            margin: '55px auto',
            flexDirection: 'column',
        },
    },
});

export default CustomerWrapperPLA;
